import type {NavigationGuard} from 'vue-router';
import {useOrderVersion} from '@/composables/useOrderVersion';

export const orderManagementGuard: NavigationGuard = () => {
  const {hasOrderManagement} = useOrderVersion();

  if (hasOrderManagement) {
    return true;
  }

  return {name: 'dashboard'};
};

export const noOrderManagementGuard: NavigationGuard = () => {
  const {hasOrderManagement} = useOrderVersion();

  if (!hasOrderManagement) {
    return true;
  }

  return {name: 'dashboard'};
};
